export default "__VITE_ASSET__TXqGPDfG__"